export default __webpack_public_path__ + "media/cuttlefish/community-content-lrg-607a4b4f.svg";